import { supabase } from './supabase';

/**
 * Invoke a Supabase Edge Function and surface the function's OWN `{ error }`
 * code on a non-2xx response (supabase-js otherwise gives a generic
 * "non-2xx status code" message). Returns `{ data, error }` where `error` is
 * the EF's error code/message string, or null on success.
 */
export async function invokeEF<T>(
  name: string,
  body: Record<string, unknown>,
): Promise<{ data: T | null; error: string | null }> {
  const { data, error } = (await supabase.functions.invoke<T>(name, { body })) as unknown as {
    data: T | null;
    error: { message?: string; context?: { json?: () => Promise<{ error?: string }> } } | null;
  };
  if (error) {
    let code: string | null = null;
    const ctx = error.context;
    if (ctx && typeof ctx.json === 'function') {
      try {
        code = (await ctx.json())?.error ?? null;
      } catch {
        code = null;
      }
    }
    return { data: null, error: code ?? error.message ?? 'Request failed.' };
  }
  const embeddedError = (data as unknown as { error?: string } | null)?.error ?? null;
  return { data: data ?? null, error: embeddedError };
}
